var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSentimentTrigger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1226 5.41667H2.69444C1.62056 5.41667 0.75 4.54611 0.75 3.47222C0.75 2.39834 1.62056 1.52778 2.69444 1.52778H10.1226M5.37738 13.9722H12.8056C13.8794 13.9722 14.75 13.1017 14.75 12.0278C14.75 10.9539 13.8794 10.0833 12.8056 10.0833H5.37738M0.75 12.0278C0.75 13.5312 1.96878 14.75 3.47222 14.75C4.97566 14.75 6.19444 13.5312 6.19444 12.0278C6.19444 10.5243 4.97566 9.30556 3.47222 9.30556C1.96878 9.30556 0.75 10.5243 0.75 12.0278ZM14.75 3.47222C14.75 4.97566 13.5312 6.19444 12.0278 6.19444C10.5243 6.19444 9.30556 4.97566 9.30556 3.47222C9.30556 1.96878 10.5243 0.75 12.0278 0.75C13.5312 0.75 14.75 1.96878 14.75 3.47222Z",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSentimentTrigger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sentiment-trigger.1113d9e6.svg";
export { ForwardRef as ReactComponent };